/**
 * Encodes a MongoDB ObjectId or string into a masked string resembling AliExpress parameters.
 * E.g., pvid=ENCODED&search=jfy&scm=...&spm=...
 */
export const encodeId = (id) => {
  if (!id) return "";
  try {
    const encoded = btoa(id);
    
    // Generate dynamic random parameters
    const randomScmPart = Math.floor(Math.random() * 1000000);
    const randomSpmPart1 = Math.floor(Math.random() * 100000000);
    const randomSpmPart2 = Math.floor(Math.random() * 1000000000);
    
    const scm = `1007.51705.${randomScmPart}.0`;
    const spm = `a2a0e.tm${randomSpmPart1}.just4u.d_${randomSpmPart2}`;
    return `pvid=${encoded}&search=jfy&scm=${scm}&spm=${spm}`;
  } catch (err) {
    return id;
  }
};

/**
 * Encodes an ID into a pattern with underscores (e.g. N_j_V_i...)
 */
export const encodeShareId = (id) => {
  if (!id) return "";
  try {
    return btoa(id).replace(/=/g, '').split('').join('_');
  } catch (err) {
    return id;
  }
};

/**
 * Decodes the masked string back to the original ID.
 * Works if the string is passed as a whole path parameter or query parameter.
 */
export const decodeId = (str) => {
  if (!str) return "";
  try {
    // If it looks like our encoded pattern, extract the base64 part
    const match = str.match(/pvid=([^&]+)/);
    if (match && match[1]) {
      return atob(match[1]);
    }
    
    // Fallback for slugs: extract from end (e.g. "shop-name-ENCODED")
    if (str.includes("-") && !/^[0-9a-fA-F]{24}$/.test(str)) {
      const parts = str.split("-");
      const encodedId = parts[parts.length - 1];
      let paddedEncodedId = encodedId;
      while (paddedEncodedId.length % 4 !== 0) {
        paddedEncodedId += "=";
      }
      return atob(paddedEncodedId);
    }

    // Fallback for underscore pattern (e.g. N_j_V_i...)
    if (str.includes("_") && !/^[0-9a-fA-F]{24}$/.test(str)) {
      const unjoined = str.replace(/_/g, '');
      let padded = unjoined;
      while (padded.length % 4 !== 0) padded += '=';
      return atob(padded);
    }

    // If it's already a clean ID, just return it
    return str;
  } catch (err) {
    return str;
  }
};
